import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AppService } from '../../../app.service';
import { AdminGridDirective, AdminGridConfig, AdminGridCallbackEvent } from '../../shared/admin-grid.directive';
import { ScreenEditComponent } from './screen-edit.component';
import { AdminScreenContextService } from '../../shared/admin-screen-context.service';

@Component({
    selector: 'gtw-screens',
    templateUrl: './screens.component.html',
    styleUrls: ['./screens.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScreensComponent implements OnInit, OnDestroy {
  @ViewChild(AdminGridDirective) adminGrid!: AdminGridDirective;

  gridConfig!: AdminGridConfig;
  loading = false;

  private readonly ACTION_ID = 77;
  private readonly GRID_ID = '32';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private dialog: MatDialog,
    private adminScreenContext: AdminScreenContextService,
  ) {}

  ngOnInit(): void {
    const clientKey = this.appService.USER_SETTINGS?.user?.client?.client_key ?? this.appService.USER_SETTINGS?.user?.client_key ?? '';
    this.gridConfig = {
      actionId: this.ACTION_ID,
      gridId: this.GRID_ID,
      extraParams: { client_key: clientKey },
      autoLoad: true,
      cacheKey: 'admin/screen-list',
    };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onGridCallback(event: AdminGridCallbackEvent): void {
    const rowData = event.data?.rowData ?? event.data;
    this.openEditModal(rowData);
  }

  onGridDataLoaded(_data: any): void {
    this.loading = false;
    this.cdr.detectChanges();
  }

  refresh(): void {
    this.adminGrid?.clearCache();
    this.adminGrid?.refresh();
  }

  addScreen(): void {
    this.openEditModal(null);
  }

  private openEditModal(rowData: any): void {
    const config = new MatDialogConfig();
    config.panelClass = 'admin-modal-panel';
    config.width = '90vw';
    config.disableClose = true;
    config.data = {
      rowData: rowData || {},
    };

    this.adminScreenContext.setRowData(rowData);
    const ref = this.dialog.open(ScreenEditComponent, config);
    ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        this.adminScreenContext.setRowData({});
        if (result === 'saved') {
          this.adminGrid?.clearCache();
          this.adminGrid?.refresh();
        }
      });
  }
}
